<template>
  <div
    v-if="showSaldo && !naoMostrarSaldo()"
    class="saldo-display"
    :title="saldos.length > 0 ? ((saldos[0].credito && saldos[0].credito.descricao) ? saldos[0].credito.descricao : saldos[0].descricao) : ''"
  >
    <span v-for="saldo in saldos" :key="saldo.id" class="saldo-item">
      <span class="saldo-label">Saldo:</span>
      <span class="saldo-badge">
        {{ saldo.saldo }}
        <span class="saldo-moeda">NCToken</span>
      </span>
      <button v-if="showRefresh" @click="refreshSaldo" class="saldo-refresh" title="Atualizar saldo">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 10A7 7 0 1 1 10 3" stroke="#4ab2e3" stroke-width="2" fill="none"/><path d="M13 3h4v4" stroke="#4ab2e3" stroke-width="2" fill="none"/></svg>
      </button>
    </span>
  </div>
</template>

<script>


import { mapState, mapActions, mapMutations } from 'vuex'

// Certifique-se de que Echo está disponível globalmente (window.Echo)

export default {
  name: 'SaldoDisplay',
  computed: {
    ...mapState('saldo', ['saldos', 'showSaldo', 'showRefresh'])
  },
  mounted() {
    this.initSaldo()
    this.listenSaldoWebSocket()
  },
  destroyed() {
    this.leaveSaldoWebSocket()
  },
  methods: {
    ...mapActions('saldo', ['fetchSaldo']),
    ...mapMutations('saldo', ['SET_SALDOS']),
    async initSaldo() {
      this.fetchSaldo()
      if (this.showSaldo) {
        try {
          const response = await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/creditos/saldo`)
          this.SET_SALDOS(response.body.data)
        } catch (e) {
          this.SET_SALDOS([])
        }
      }
    },
    async refreshSaldo() {
      this.fetchSaldo()
      if (this.showSaldo) {
        try {
          const response = await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/creditos/saldo`)
          this.SET_SALDOS(response.body.data)
        } catch (e) {
          this.SET_SALDOS([])
        }
      }
    },
    listenSaldoWebSocket() {
      const autoescola = JSON.parse(localStorage.getItem('autoescola'))
      if (!autoescola || !window.Echo) return
      
      const channel = Echo.private(`SaldoCreditos.${autoescola.id_cfc}`)
      // Tentativa 2: Com namespace completo (ajuste conforme seu namespace)
      channel.listen('.SaldoAtualizado', event => {
        this.updateSaldo(event)
      })
    },
    updateSaldo(event) {
      if (event && event.saldo) {
        this.SET_SALDOS(event.saldo)
      } else if (event) {
        // Tenta parse se for string
        try {
          const parsed = typeof event === 'string' ? JSON.parse(event) : event
          if (parsed.saldo) {
            this.SET_SALDOS(parsed.saldo)
          }
        } catch (e) {
          console.error('Erro ao fazer parse do evento:', e)
        }
      }
    },
    leaveSaldoWebSocket() {
      const autoescola = JSON.parse(localStorage.getItem('autoescola'))
      if (!autoescola || !window.Echo) return
      Echo.leave(`private-SaldoCreditos.${autoescola.id_cfc}`)
    },
    naoMostrarSaldo() {
      const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
      const idFuncao = usuario.id_funcao_usuario
      return idFuncao === 2 || idFuncao === 6
    },
  }
}
</script>

<style scoped>
.saldo-display {
  display: flex;
  align-items: center;
  margin-left: 4px;
  gap: 0.5rem;
}
.saldo-item {
  display: flex;
  align-items: center;
  background: #e8fff3;
  border: 1px solid #4ae387;
  border-radius: 16px;
  padding: 0.15rem 0.75rem 0.15rem 0.5rem;
  font-weight: 500;
  color: #34495e;
  margin-right: 0.5rem;
  box-shadow: 0 1px 4px rgba(76, 227, 135, 0.07);
  font-size: 1rem;
}
.saldo-icon {
  margin-right: 0.4rem;
  display: flex;
  align-items: center;
}
.saldo-label {
  margin-right: 0.3rem;
  font-size: 0.98em;
  color: #4ab2e3;
  font-weight: 600;
}
.saldo-badge {
  background: #4ae387;
  color: #fff;
  border-radius: 8px;
  padding: 0.1rem 0.6rem;
  font-weight: bold;
  margin: 0 0.3rem;
  font-size: 1.08em;
  letter-spacing: 0.5px;
}
.saldo-moeda {
  font-size: 0.95em;
  color: #4ab2e3;
  margin-right: 0.2rem;
}
.saldo-refresh {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.2rem;
  padding: 0.1rem;
  display: flex;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.saldo-refresh:hover {
  opacity: 1;
}
</style>
